<template>
  <section class="invoice">
    <h4>Credits</h4>
    <LoadingSpinner v-if="loading" />
    <div class="mx-2" v-else>
      <div class="col-md-12 my-2 card p-2">
        <div class="d-flex flex-wrap">
          <div class="col-md-4 input-group input-group-sm p-1 treeselect-wrapper">
            <div class="input-group-prepend">
              <span class="input-group-text" id="inputGroup-sizing-sm">Manager</span>
            </div>
            <IndustrySearch
              :option_list="userOliverSales"
              :default_values="userOliverSale"
              :key="key"
              :multiple="false"
              @selected="selectOliverSale"
              :isDisabled="loading"
              class="form-control inline-table"
            />         
          </div>
          <div class="col-md-4 input-group input-group-sm p-1">
            <div class="input-group-prepend">
              <span class="input-group-text" id="inputGroup-sizing-sm">Date</span>
            </div>
            <date-picker
              id="monthDatePicker"
              class="form-control"
              v-model="filterMonth"
              :config="datePickerConfig"
              placeholder="Select Month"
            ></date-picker>
          </div>
          <button
            class="btn btn-success col-md-2"
            @click="applyFilters()"
            :disabled="loading"
          >
            <i class="icon-calendar-check-o mr-2"></i>
            <small>Filter</small>
          </button>
        </div>
      </div>
      <div class="table-responsive px-0 mt-4">
        <div class="row" v-if="Object.entries(opportunities).length == 0 && !loading">
          <div class="col-12 col-md-10 offset-md-1 text-center " >
            <div class="alert alert-primary mx-5 my-2 px-2 py-4 ">
              <h6>
                <i class="fas fa-exclamation-triangle mr-2"></i>
                {{ $t("lang.label.nothingplannedatthemoment")}}
               </h6>
            </div>
          </div>
        </div>
        <table
          clsas="table table-hover card-style min-width-table card-style"
          class="dashboard-report-credits-table"
          width="100%"
        >
          <template v-for="(listYear, year) in opportunities">
            <tr
              :key="year"
              v-if="$options.lastYear == undefined || $options.lastYear != year"
              class="bg-dark"
            >
              <td :colspan="tableColumnCount">
                <span class="text-white ml-2 font-weight-bold">{{ year }}</span>
              </td>
            </tr>
            <template v-for="(listMonth, month) in listYear">
              <template class="pb-2">
  
                <tr
                  :key="month + year"
                  class="accordion"
                  id="accordionlocation"
                  v-if="
                    $options.lastMonth == undefined || $options.lastMonth != month
                  "
                >
                  <td :colspan="tableColumnCount">
                    <div
                      class="p-0 mt-3 bg-light w-100 align-left"
                      type="button"
                      data-toggle="collapse"
                      :data-target="'#collapseLocation' + year + month"
                      aria-expanded="true"
                      :aria-controls="'collapseLocation' + year + month"
                    >
                      <span> {{ getLabelMonth(month) }} </span>
  
                      <span
                        class="badge badge-warning ml-2"
                        v-if="
                          absent[year] !== undefined &&
                          absent[year][month] !== undefined
                        "
                        >{{ $t("lang.refuse.absentlabel") }}
                        {{ absent[year][month].total }}</span
                      >
  
                      <span
                        v-if="
                          refused[year] !== undefined &&
                          refused[year][month] !== undefined
                        "
                        class="badge badge-danger ml-2"
                        >{{ $t("lang.refuse.refused") }}
                        {{ refused[year][month].total }}</span
                      >
  
                      <span
                        v-if="
                          active[year] !== undefined &&
                          active[year][month] !== undefined
                        "
                        class="badge badge-success text-white ml-2"
                        >{{ $t("lang.refuse.valid") }}
                        {{ active[year][month].total }}</span
                      >
  
                      <strong
                        v-if="hasPermissions('manageBilling')"
                        class="float-right"
                        >Total: {{ getTotal(year, month) }} € TTC ( {{ calculatePercentage(getTotal(year, month) , getDataByMonthAndYear(year, month)) }} %)</strong
                      >
                    </div>
                    <div class="dropdown-divider"></div>
                  </td>
                </tr>
  
                <tbody
                  wdth="100%"
                  :key="year + month"
                  :id="'collapseLocation' + year + month"
                  class="collapse show ml-4"
                  :aria-labelledby="'collapseLocation' + year + month"
                >
                    <tr>
                      <th class="small"><b>{{ $t("lang.label.status") }}</b></th>
                      <th class="small"><b>{{ $t("lang.label.client") }}</b></th>
                      <th class="small"><b>Account Manager</b></th>
                      <th class="small">User</th>
                      <th class="small"><b>{{ $t("lang.column.reason") }}</b></th>
                      <th class="small"><b>{{ $t("lang.column.description") }}</b></th>
                      <th class="small"><b>{{ $t("lang.column.more_details") }}</b></th>
                      <th class="small"><b>{{ $t("lang.column.date") }}</b></th>
                      <th class="small text-right" v-if="hasPermissions('manageBilling') && vat > 1"><b>{{ $t("lang.appointments.meetingprice") }}  (€ H.T)</b></th>
                      <th class="small text-right" v-if="hasPermissions('manageBilling')"><b>{{ $t("lang.appointments.meetingprice") }}</b></th>
                      <th class="small text-center font-weight-bold">{{ $t("lang.column.delete_credits") }}</th>
                    </tr>
                  <tr
                    v-for="(credit, index) in listMonth"
                    :key="year + month + index"
                  >
                    <td>
                      <span :class="getClass(credit)" class="mr-3">{{
                        getText(credit)
                      }}</span>
                    </td>
                    <td>
                      <span class="mr-3">
                        <a
                         class="text-primary"
                        target="_blank"
                        :href="'/clients/' + credit.client_id"
                        >
                          {{ credit.company_name }}
                        </a>
                      </span
                      >
                    </td>
                    <td>
                      <small class="mr-3">
                          {{ credit.oliver_sale }}
                      </small>
                    </td>
                    <td>
                      <small class="mr-3">
                          {{ credit.creditor_username }}
                      </small>
                    </td>
                    <td>
                      <small>{{ credit.reason }}</small>
                    </td>
                    <td>
                      <small>
                        <a
                          class="text-primary"
                          target="_blank"
                          :href="credit.link_id != null ? '/opportunities/' + credit.link_id : '#'"
                          >{{ credit.business_name }}
                        </a>
                      </small>
                    </td>
                    <td>
                      <small class="bg bg-secondary text-white text-center" style="border-radius: 5px; padding: 1px 5px;">
                        <Tooltip :text="credit.description != null ? credit.description : $t('lang.label.nothing_for_now')">
                          <small>Info <i class="icon-info text-white"></i></small>
                        </Tooltip>
                      </small>
                    </td>
                    <td>
                      <small>{{
                        credit.real_event_date != null
                          ? credit.real_event_date
                          : credit.event_date
                      }}</small>
                    </td>
                    <td class="text-right" v-if="hasPermissions('manageBilling') && vat > 1">
                      <small><strong class="mr-3">{{ getPrice(credit) }} € H.T</strong></small>
                    </td>
                    <td class="text-right" v-if="hasPermissions('manageBilling')">
                      <small><strong>{{ getPriceIva(credit) }} € TTC</strong></small>
                    </td>
                    <td class="text-center">
                      <button class="btn btn-danger" :disabled="credit.payment_id != null" @click="deleteCredits(credit.id)">X</button>
                    </td> 
                  </tr>
                </tbody>
              </template>
              <template :set="($options.lastMonth = month)"></template>
            </template>
            <template :set="($options.lastYear = year)"></template>
          </template>
        </table>
      </div>
    </div>
  </section>
</template>
<script>
import { billingsService, usersService } from "@/_services";
import { mapState, mapActions } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import Tooltip from "@/components/Common/Tooltip.vue";
import moment from "moment";

export default {
  data() {
    return {
      userOliverSales: [{ id: "0", label: "All" }],
      userOliverSale: ["0"],
      userOliverSaleId: null,
      oliverSalesLoaded: false,
      loading: true,
      opportunities: {},
      total: {},
      active: {},
      refused: {},
      totalexported: {},
      absent: {},
      totalexp: 0,
      billingProfile: {},
      totalByMonths: {},
      key: 0,
      datePickerConfig: {
        format: "YYYY-MMM",
        viewMode: "months",
        minDate: moment().subtract(12, "month"),
        maxDate: moment().endOf("day"),
      },
      filterMonth: moment().format("YYYY-MMM"),
    };
  },
  props: {
    userId: {
      type: String,
      default: null,
    },
  },
  components: {
    LoadingSpinner,
    IndustrySearch,
    Tooltip,
  },
  lastYear: undefined,
  lastMonth: undefined,
  created() {
    // crmService.getContactSent().then((result) => {
    //   result.forEach((item) => {
    //     if (this.totalexported[item.event_year] == undefined) {
    //       this.totalexported[item.event_year] = {};
    //     }
    //     if (
    //       this.totalexported[item.event_year][item.event_month] == undefined
    //     ) {
    //       this.totalexported[item.event_year][item.event_month] = {
    //         total: item.quantity,
    //       };
    //     } else {
    //       let total =
    //         this.totalexported[item.event_year][item.event_month] +
    //         item.quantity;
    //       this.totalexported[item.event_year][item.event_month] = {
    //         total: total,
    //       };
    //     }
    //   });
    // });

    this.getBillingProfile();
    const filterD = moment(this.filterMonth, "YYYY-MMM").format("YYYY-MM");
    this.getData(filterD);
    this.getDataTotalByMonth(null, filterD);
    this.getUserOliverSales();
  },

  computed: {
    user() {
      return this.$store.state.authentication.user;
    },
    vat() {
      return this.billingProfile.country_id == 73 ? 1.2 : 1;
    },
    /** Must match the real number of <th>/<td> columns per row (fixes header vs body width). */
    tableColumnCount() {
      let cols = 9; // 8 + delete
      if (this.hasPermissions("manageBilling") && this.vat > 1) {
        cols += 1; // € H.T
      }
      if (this.hasPermissions("manageBilling")) {
        cols += 1; // € TTC
      }
      return cols;
    },
  },

  methods: {
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    getUserOliverSales() {
      this.oliverSalesLoaded = true;
      usersService
        .getUserOliverSales(true, false, true)
        .then((res) => {
          if (res.result.length > 0) {
            const userOliverSalesWithlabel = res.result.map((el) => ({
              ...el,
              label: el.lastname + ", " + el.name,
            }));
            this.userOliverSales.push(...userOliverSalesWithlabel);
            
            this.oliverSalesLoaded = true;
            this.userOliverSales.map((it) => {
              if (it.id == this.user.id) {
                this.userOliverSaleId = it.id;
                this.userOliverSale = [it.id.toString()];
              }
            });
            this.key++;
          }
        })
        .catch((err) => console.error(err));
    },
    selectOliverSale(value) {
      // Si se selecciona "All" (id = "0"), enviar null al endpoint
      this.userOliverSaleId = value.id === "0" ? null : value.id;
      this.applyFilters();
    },
    applyFilters() {
      const filterD = moment(this.filterMonth, "YYYY-MMM").format("YYYY-MM");
      
      if(this.userOliverSaleId){
        this.getDataTotalByMonth(this.userOliverSaleId, filterD);
      } else {
        this.getDataTotalByMonth(null, filterD);
      }
      
      this.getData(filterD);
    },
    hasData(year, month) {
      return (
        (this.refused !== undefined &&
          this.refused[year] !== undefined &&
          this.refused[year][month] !== undefined) ||
        (this.active !== undefined &&
          this.active[year] !== undefined &&
          this.active[year][month] !== undefined) ||
        (this.absent !== undefined &&
          this.absent[year] !== undefined &&
          this.absent[year][month] !== undefined) ||
        (this.totalexported !== undefined &&
          this.totalexported[year] !== undefined &&
          this.totalexported[year][month] !== undefined)
      );
    },
    getBillingProfile() {
      billingsService.getBillingProfile(this.userId).then((result) => {
        if (result) {
          this.billingProfile = result;
        } else {
          this.billingProfile = {
            name: "",
            legal_representative: "",
            address: "",
            country_id: 73,
            contact_name: "",
            contact_email: "",
          };
          this.loading = false;
        }
      });
    },
    deleteCredits(id){
      this.$swal({
        type: "warning",
        title: this.$t('lang.label.credit_deleted_sure'),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.ok"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          billingsService.deleteCreditToClient(id)
          .then(() => {
            this.$swal({
              type: "success",
              title: this.$t("lang.label.great"),
              showConfirmButton: false,
              timer: 2000,
            });
          })
          .catch(() => {
            this.$swal({
              type: "error",
              title: this.$t("lang.label.error"),
            });
          })
          .finally(() => {
            const filterD = moment(this.filterMonth, "YYYY-MMM").format("YYYY-MM");
            this.getData(filterD);
            this.getDataTotalByMonth(null, filterD);
          });
        }
      });
    },
    getData(yearMonth = null) {
      this.loading = true;
      
      // Resetear todos los datos antes de cargar los nuevos
      this.opportunities = {};
      this.active = {};
      this.refused = {};
      this.absent = {};
      this.total = {};
      
      // Resetear las variables de control del template
      this.$options.lastYear = undefined;
      this.$options.lastMonth = undefined;
      
      const params = {
        user_id: this.userOliverSaleId || null
      };
      
      if (yearMonth) {
        params.yearMonth = yearMonth;
      }
      
      billingsService
        .getCredits(params)
        .then((result) => {
          result.forEach((item) => {

            if (this.opportunities[item.event_year] == undefined) {
              this.opportunities[item.event_year] = {};
            }
            if (
              this.opportunities[item.event_year][item.event_month] == undefined
            ) {
              this.opportunities[item.event_year][item.event_month] = [];
            }
            this.opportunities[item.event_year][item.event_month].push(item);

            if (item.link_status_reason_id == 35) {
              if (this.absent[item.event_year] == undefined) {
                this.absent[item.event_year] = {};
              }
              if (this.absent[item.event_year][item.event_month] == undefined) {
                this.absent[item.event_year][item.event_month] = { total: 0 };
              }
              this.absent[item.event_year][item.event_month].total++;
            } else if (item.link_status_reason_id == 34) {
              if (this.refused[item.event_year] == undefined) {
                this.refused[item.event_year] = {};
              }
              if (this.refused[item.event_year][item.event_month] == undefined) {
                this.refused[item.event_year][item.event_month] = { total: 0 };
              }
              this.refused[item.event_year][item.event_month].total++;
            } else {
              if (this.active[item.event_year] == undefined) {
                this.active[item.event_year] = {};
              }
              if (this.active[item.event_year][item.event_month] == undefined) {
                this.active[item.event_year][item.event_month] = {
                  total: 0,
                  totalAmount: 0,
                };
              }

              this.active[item.event_year][item.event_month].total++;
              this.active[item.event_year][item.event_month].totalAmount =
                this.active[item.event_year][item.event_month].totalAmount +
                parseFloat(item.amount);
            }
          });
        })
        .then((result) => {
          this.loading = false;
          this.$forceUpdate();
          this.$nextTick(() => {
            this.openAllAccordions();
          });
        });
    },
    async getDataTotalByMonth(oliver_sale = null, yearMonth = null) {  // para separar año-mes, money 
     
      this.totalByMonths = {}
      const params = {
        accountManager: oliver_sale
      };
      
      if (yearMonth) {
        params.yearMonth = yearMonth;
      }
      
      try {
        this.totalByMonths = await billingsService.getTotalCredits(params);
      } catch (error) {
        console.error('Error obteniendo datos por mes', error);
      } finally {
        this.loading = false;
      }
    },
    getDataByMonthAndYear(year, month) {
      let result = null;
      let found = false;

      if (!Array.isArray(this.totalByMonths)) {
        return ;
      }

      this.totalByMonths.forEach((item) => {
        if (found) {
          return; // Si ya encontramos el elemento, salimos del forEach
        }

        if (item.year === year && item.month === month) {
          result = item.money;
          found = true; // Marcamos que encontramos el elemento
        }
      });

      if (result === null) {
        return ;
      }

      return result;

    },
    calculatePercentage(total, dataByMonth) {
      if (total === 0) {
        return 0; // Evitar división por cero
      }
      total = Math.abs(total); // Convertir total a valor absoluto
      dataByMonth = parseFloat(dataByMonth).toFixed(2); // Redondear dataByMonth a dos decimales
      return ((total  / dataByMonth) * 100).toFixed(2);
    },
    getTotal(year, month) {
      let total = 0;
      if (
        this.active[year] !== undefined &&
        this.active[year][month] !== undefined
      ) {
        total = this.active[year][month].totalAmount;
      }
      let totalexp = 0;
      // if (
      //   this.totalexported[year] !== undefined &&
      //   this.totalexported[year][month] !== undefined
      // ) {
      //   totalexp = totalexp + this.totalexported[year][month].total * 0.05;
      // }
      total = (total + totalexp) * 1.2;
      return parseFloat(total).toFixed(2);
    },
    getCurrentMonth() {
      var d = new Date();
      var weekday = new Array(7);
      weekday[0] = this.$t("lang.label.january");
      weekday[1] = this.$t("lang.label.frebruary");
      weekday[2] = this.$t("lang.label.march");
      weekday[3] = this.$t("lang.label.april");
      weekday[4] = this.$t("lang.label.may");
      weekday[5] = this.$t("lang.label.june");
      weekday[6] = this.$t("lang.label.july");
      weekday[7] = this.$t("lang.label.august");
      weekday[8] = this.$t("lang.label.september");
      weekday[9] = this.$t("lang.label.october");
      weekday[10] = this.$t("lang.label.november");
      weekday[11] = this.$t("lang.label.december");
      return weekday[d.getMonth()];
    },
    getYear() {
      var d = new Date();
      return d.getFullYear();
    },
    getLabelMonth(month) {
      var weekday = new Array(7);
      weekday[1] = this.$t("lang.label.january");
      weekday[2] = this.$t("lang.label.frebruary");
      weekday[3] = this.$t("lang.label.march");
      weekday[4] = this.$t("lang.label.april");
      weekday[5] = this.$t("lang.label.may");
      weekday[6] = this.$t("lang.label.june");
      weekday[7] = this.$t("lang.label.july");
      weekday[8] = this.$t("lang.label.august");
      weekday[9] = this.$t("lang.label.september");
      weekday[10] = this.$t("lang.label.october");
      weekday[11] = this.$t("lang.label.november");
      weekday[12] = this.$t("lang.label.december");
      return weekday[month];
    },
    getClass(opportunity) {
      if (opportunity.link_status_reason_id == 35) {
        return "badge badge-warning";
      }
      if (opportunity.link_status_reason_id == 34) {
        return "badge badge-danger";
      }
      if(opportunity.billing_status == 'next_pay'){
        return "icon-dollar text-secondary";
      }
      if(opportunity.billing_status == 'pay_declined'){
        return "icon-dollar text-danger";
      }
      if(opportunity.billing_status == 'pay_pending'){
        return "icon-dollar text-warning";
      }
      if (opportunity.real_event_date != null || opportunity.billing_status == 'pay_paid') {
        return "icon-dollar text-success";
      }
      return "icon-calendar text-success";
    },
    getText(opportunity) {
      if (opportunity.link_status_reason_id == 35) {
        return this.$t("lang.refuse.absentlabel");
      }
      if (opportunity.link_status_reason_id == 34) {
        return this.$t("lang.refuse.refused");
      }
      return "";
    },
    getPrice(opportunity) {
      return parseFloat(opportunity.amount).toFixed(2);
    },
    getPriceIva(opportunity) {
      return parseFloat(opportunity.amount * this.vat).toFixed(2);
    },
    getPriceContacts(amount) {
      return parseFloat(amount * 0.0).toFixed(2);
    },
    getPriceContactsIva(amount) {
      return parseFloat(amount * 0.0 * this.vat).toFixed(2);
    },
    openAllAccordions() {
      this.$nextTick(() => {
        Object.keys(this.opportunities).forEach((year) => {
          Object.keys(this.opportunities[year]).forEach((month) => {
            const collapseId = `collapseLocation${year}${month}`;
            const collapseElement = document.getElementById(collapseId);
            if (collapseElement) {
              if (window.$ && window.$.fn.collapse) {
                window.$(`#${collapseId}`).collapse("show");
              } else if (window.bootstrap && window.bootstrap.Collapse) {
                const bsCollapse = new window.bootstrap.Collapse(
                  collapseElement,
                  { toggle: false }
                );
                bsCollapse.show();
              }
            }
          });
        });
      });
    },
  },
};
</script>
<style scoped>
/* Espaciado entre columnas + ancho mínimo: el scroll horizontal lo gestiona .table-responsive */
.dashboard-report-credits-table {
  width: 100%;
  min-width: 1220px;
  border-collapse: separate;
  border-spacing: 0;
}
.dashboard-report-credits-table th,
.dashboard-report-credits-table td {
  padding: 0.5rem 0.75rem;
  vertical-align: middle;
}
.dashboard-report-credits-table th.text-right,
.dashboard-report-credits-table td.text-right {
  white-space: nowrap;
  min-width: 7rem;
}
.dashboard-report-credits-table th.text-center,
.dashboard-report-credits-table td.text-center {
  min-width: 4.5rem;
}
</style>
